import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { TimelineMax, TweenMax } from 'gsap';

import createTitleFadeInAnimation from '../../animations/titleFadeIn';
import createTitleFadeOutAnimation from '../../animations/titleFadeOut';

const propTypes = {
    title: PropTypes.string.isRequired,
    tapToReveal: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

const defaultProps = {
    onClick: null,
};

class Title extends Component {
    constructor(props) {
        super(props);

        this.onClickTitle = this.onClickTitle.bind(this);

        this.timelineFadeIn = null;
        this.timelineFadeOut = null;

        this.refContainer = null;
        this.refTitle = null;

        this.state = {
            indicationVisible: false,
        };
    }

    componentDidMount() {
        this.timelineFadeIn = createTitleFadeInAnimation({
            title: this.refTitle,
            tapIndication: this.refTapIndication,
            onTapFadeInStart: () => {
                this.setState(() => ({
                    indicationVisible: true,
                }));
            },
        }).paused(true);

        this.timelineFadeOut = new TimelineMax({
            paused: true,
        });
        this.timelineFadeOut.addCallback(() => {
            if (!this.state.indicationVisible) {
                TweenMax.set(this.refTapIndication, {
                    autoAlpha: 0,
                })
            }
        });
        this.timelineFadeOut.add(createTitleFadeOutAnimation({
            title: this.refContainer,
            tapIndication: this.refTapIndication,
        }));
    }

    onClickTitle() {
        const { onClick } = this.props;
        if (onClick) {
            onClick();
        }
    }

    getTimelineFadeIn() {
        return this.timelineFadeIn;
    }

    getTimelineFadeOut() {
        return this.timelineFadeOut;
    }

    render() {
        const {
            title,
            tapToReveal,
        } = this.props;
        return (
            <div
                className="slide fullscreen slide-title"
                ref={(ref) => { this.refContainer = ref; }}
            >
                <button type="button" className="btn-fullscreen" onClick={this.onClickTitle}>
                    <span className="table fullscreen">
                        <span className="cell middle">
                            <span className="title-container">
                                <strong
                                    className="title"
                                    ref={(ref) => { this.refTitle = ref; }}
                                >
                                    <ReactMarkdown
                                        containerTagName="span"
                                        source={title}
                                    />
                                </strong>
                                <span
                                    className="bottom-indication"
                                    ref={(ref) => { this.refTapIndication = ref; }}
                                >{tapToReveal}</span>
                            </span>
                        </span>
                    </span>
                </button>
            </div>
        );
    }
}

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;



// WEBPACK FOOTER //
// ./components/partials/Title.jsx